import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { FlexColumn } from "@similarweb/ui-components";

import { LIST_HEIGHT } from "app/pages/activation/components/ProjectsList/constants";

const { carbon } = colorsPalettes;

export const Container = styled(FlexColumn)`
    width: 100%;
    height: ${LIST_HEIGHT}px;
    justify-content: center;
    align-items: center;
    gap: 16px;
    background-color: ${carbon[0]};
    border-radius: 6px;
    box-shadow: 0 3px 6px 0 rgba(14, 30, 62, 0.08);
`;

export const EmptyImage = styled.img`
    width: 240px;
`;

export const Subtitle = styled.h4`
    ${setFontVariant("subtitle1", carbon[500])};
    margin: 0;
    padding: 0;
`;

export const Body = styled.div`
    ${setFontVariant("body2", carbon[400])};
    margin: 0;
    padding: 0;
    max-width: 378px;
`;

export const Content = styled.div`
    text-align: center;
`;
